import { ComboDetailModule } from '@/modules/product/combo/combo-detail/index';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const paramsSchema = z.object({
  id: z.coerce.string(),
});

export const Route = createFileRoute('/dashboard/product/combo/$id')({
  params: {
    parse: params => paramsSchema.parse(params),
    stringify: params => ({ id: String(params.id) }),
  },
  component: ComboDetailModule,
});
